import { AccountInvoices } from "../account/AccountInvoices"
import { useAccount, useInvoices } from "../state/AppDataStateProvider"
import Container from "@mui/material/Container"

export const AccountInvoicesPage = () => {
    const account = useAccount()
    const invoices = useInvoices(account?.id)

    console.log(invoices)

    return (
        <Container maxWidth="md">
            <AccountInvoices invoices={invoices} />
        </Container>
    )
}